export const AddPromoProductToCart = () => ({
  atcBtn: '.promo-product-btn',

  addPromoProductToCart(e) {
    e.preventDefault();

    const button = document.querySelector(this.atcBtn);

    if (button) {
      button.click();
    }
  }
});
